$(() => {
  $(".js-omcookie-reset").on({
    click: (e) => {
      omCookieUtility.setCookie("omCookieConsent",  '', -1);
      location.reload();
    }
  });

});
